<template>
  <a-card :bordered="false">

    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">
            <a-col :span="24">
                <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
                  <a-button type="primary" @click="searchQuery" icon="search">查询</a-button>
                  <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">重置</a-button>
                  <a-button @click="handleAdd" type="primary" icon="plus" style="margin-left: 8px">新增</a-button>
                </span>
          </a-col>
        </a-row>
      </a-form>
    </div>

    <!-- table区域-begin -->
    <div>
      <a-table
        ref="table"
        size="middle"
        bordered
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        class="j-table-force-nowrap"
        @change="handleTableChange">
        <span slot="action" slot-scope="text, record">
          <a @click="handleEdit(record)">编辑</a>
          <a-divider type="vertical" />
          <a-dropdown>
            <a class="ant-dropdown-link">更多 <a-icon type="down" /></a>
            <a-menu slot="overlay">
              <a-menu-item>
                <a-popconfirm title="确定删除吗?" @confirm="() => handleDelete(record.id)">
                  <a>删除</a>
                </a-popconfirm>
              </a-menu-item>
            </a-menu>
          </a-dropdown>
        </span>

      </a-table>
    </div>
    <!-- table区域-end -->
    <!-- 表单区域 -->
    <projectResultConfig2-modal ref="modalForm" @ok="modalFormOk"></projectResultConfig2-modal>
  </a-card>
</template>

<script>
  import '@/assets/less/TableExpand.less'
  import ProjectResultConfig2Modal from './modules/ProjectResultConfig2Modal'
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import {CACHE_PROJECT_ID} from '@/constants/project'
  import Vue from 'vue'
  export default {
    name: "ProjectResultConfig2List",
    mixins:[JeecgListMixin],
    components: {
      ProjectResultConfig2Modal
    },
    data () {
      return {
        projectId: Vue.ls.get(CACHE_PROJECT_ID),
        description: '测试逻辑结果总评价配置管理页面',
        // 表头
        columns: [
		   {
            title: '评价描述',
            align:"center",
            dataIndex: 'description'
           },
		   {
            title: '个人值大于平均值的最小个数',
            align:"center",
            dataIndex: 'minAvg'
           },
		   {
            title: '个人值大于平均值的最大个数',
            align:"center",
            dataIndex: 'maxAvg'
           },
          {
            title: '操作',
            dataIndex: 'action',
            align:"center",
            scopedSlots: { customRender: 'action' },
          }
        ],
		url: {
          list: "/project/projectResultConfig2/list",
          delete: "/project/projectResultConfig2/delete",
       },
        isorter:{
          column: '',
          order: '',
        },
        disableMixinCreated:true,
    }
  },
  computed: {
  },
    mounted(){
      this.baseQueryParam = {projectId:this.projectId}
      this.loadData()
    },
    methods: {

    }
  }
</script>
<style scoped>
  @import '~@assets/less/common.less';
</style>